<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="submit" title="Guardar" class="btn btn-outline-success"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">        
        <h4 style="display:inline">Re-Exportación {{solicitudReexportacion.CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <img class="estado-icono-big" container="body" src="{{ solicitudReexportacion?.IdTipoSolicitudEx | IconoTipoSolicitudEx }}" ngbTooltip="{{ solicitudReexportacion?.IdTipoSolicitudExDescripcion }}" />
                <img class="estado-icono-big" container="body" src="{{ solicitudReexportacion?.IdEstadoSolicitudEx | IconoEstadoSolicitudEx }}" ngbTooltip="{{ solicitudReexportacion?.IdEstadoSolicitudExDescripcion }}" />
                <img *ngIf="solicitudReexportacion?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || solicitudReexportacion?.IdSubTipoSolicitudEx === reExpConAtestFito || solicitudReexportacion?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{solicitudReexportacion?.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{solicitudReexportacion?.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{ solicitudReexportacion?.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx }}" ngbTooltip="{{ solicitudReexportacion?.IdEstadoCertificadoFitoExDescripcion }}" />
                <img *ngIf="solicitudReexportacion?.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{solicitudReexportacion?.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudReexportacion?.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row mt-2">
            <div class="col-md-12">

                <ng-container *ngIf="idSolicitudEx">
                    <app-alertarechazo [id]="idSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <div class="card card-accent-success animated fadeIn mb-3">

                    <div class="card-header">
                        <i class="fa fa-align-justify"></i> Rellene y marque las casillas que se ajusten a su solicitud:
                    </div>

                    <div class="card-body-detalle">

                        <div class="row mt-4">

                            <div class="form-group col-md-4">
                                <label class="col-form-label required-field" for="">1. Nº Certificado Fitosanitario que ampara a la mercancía</label>
                                <input formControlName="NumCertificadoReex" maxlength="50" name="NumCertificadoReex" title="" class="form-control" [ngClass]="displayFieldCss('NumCertificadoReex')" id="" type="text" value="">

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumCertificadoReex','required')">
                                    Nº Certificado es obligatorio
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('NumCertificadoReex','minlength')">
                                    Nº Certificado debe tener 1 carácter como mínimo
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-4">
                                <label class="col-form-label required-field" for="">Certificado</label>
                                <div class="container">
                                    <div class="row align-items-star mt-2">
                                        <div class="col">
                                            <p-radioButton formControlName="Original" inputStyleClass="form-control" [ngClass]="displayFieldCss('Original')" name="Original" value="S" label="Original"></p-radioButton>
                                        </div>
                                        <div class="col">
                                            <p-radioButton formControlName="Original" inputStyleClass="form-control" [ngClass]="displayFieldCss('Original')" name="Original" value="N" label="Copia Fiel Certificada"></p-radioButton>
                                        </div>
                                    </div>
                                    <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Original','required')">
                                        Tipo Certificado es obligatorio
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row mt-5">
                            <div class="form-group col-md-4">
                                <label class="col-form-label required-field" for="">2. Los productos están:</label>
                                <div class="container">
                                    <div class="row align-items-star mt-2">
                                        <div class="col">
                                            <p-radioButton formControlName="Empacados" inputStyleClass="form-control" [ngClass]="displayFieldCss('Empacados')" name="Empacados" value="S" label="Empacados"></p-radioButton>
                                        </div>
                                        <div class="col">
                                            <p-radioButton formControlName="EnvaseOriginal" inputStyleClass="form-control" [ngClass]="displayFieldCss('EnvaseOriginal')" name="EnvaseOriginal" value="S" label="En envases originales"></p-radioButton>
                                        </div>

                                    </div>
                                    <div class="row align-items-star mt-2">
                                        <div class="col">
                                            <p-radioButton formControlName="Empacados" inputStyleClass="form-control" [ngClass]="displayFieldCss('Empacados')" name="Empacados" value="N" label="Reempacados"></p-radioButton>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Empacados','required')">
                                                Tipo empacado es obligatorio
                                            </div>
                                        </div>
                                        <div class="col">
                                            <p-radioButton formControlName="EnvaseOriginal" inputStyleClass="form-control" [ngClass]="displayFieldCss('EnvaseOriginal')" name="EnvaseOriginal" value="N" label="En envases nuevos"></p-radioButton>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('EnvaseOriginal','required')">
                                                Tipo envase es obligatorio
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-5">
                            <div class="form-group col-md-12">
                                <label class="col-form-label" [ngClass]="{ 'required-field': certificadoOInsAdicionalRequired }">3. Se considera que se ajusta a las disposiciones fitosanitarias del país importador, basándose en: (El servicio de Sanidad Vegetal marcará este apartado)</label>
                            </div>
                        </div>

                        <div class="row mb-4">
                            <div class="form-group col-md-6">
                                <div class="container">
                                    <div class="row align-items-star mt-2">
                                        <div class="col">
                                            <label class="p-radiobutton-label" [ngClass]="{ 'required-field': certificadoOInsAdicionalRequired }" for="CertFitoOriginal">El Certificado Fitosanitario original</label>
                                            <p-toggleButton class="form-control-togglebutton ms-2 mt-2" formControlName="CertFitoOriginal" [ngClass]="displayFieldCssToggleButton('CertFitoOriginal')" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times" id="CertFitoOriginal" aria-describedby="validationGrupo3Feedback"></p-toggleButton>
                                        </div>
                                        <div class="col">
                                            <label class="p-radiobutton-label" [ngClass]="{ 'required-field': certificadoOInsAdicionalRequired }" for="InspAdicional">La inspección adicional</label>
                                            <p-toggleButton class="form-control-togglebutton ms-2 mt-2" formControlName="InspAdicional" [ngClass]="displayFieldCssToggleButton('InspAdicional')" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times" id="InspAdicional" aria-describedby="validationGrupo3Feedback"></p-toggleButton>
                                        </div>
                                    </div>
                                    <div id="validationGrupo3Feedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('CertFitoOriginal','required')">
                                        Debe seleccionar al menos una opción del punto 3
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



</form>
